'use client';

import { c as _c } from "react/compiler-runtime";
import type { ContentSectionFieldsFragment, FaqFieldFieldsFragment, Maybe } from '@/modules/__generated__/graphql/switchboard-generated';
import { FaqSection } from '@/modules/service-profile/components/faq/faq';
import { Markdown } from '@/modules/shared/components/markdown/markdown';
import { ExpandableSection } from './expandable-section';
export interface ProductInfoProps {
  description?: Maybe<string>;
  contentSections: ContentSectionFieldsFragment[];
  faqFields?: Maybe<FaqFieldFieldsFragment[]>;
}
function ProductInfo(t0) {
  const $ = _c(12);
  const {
    description,
    contentSections,
    faqFields
  } = t0;
  const t1 = description ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = <Markdown className="text-foreground">{t1}</Markdown>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== contentSections) {
    t3 = contentSections.map(_temp);
    $[2] = contentSections;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex flex-col gap-4">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== faqFields) {
    t5 = faqFields && faqFields.length > 0 && <FaqSection faqFields={faqFields} />;
    $[6] = faqFields;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-6">{t2}{t4}{t5}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(section) {
  return <ExpandableSection key={section.id} title={section.title} description={section.content} />;
}
export { ProductInfo };